import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

const PopoverContentsStyles = css`
  outline: 0;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.transcendNavy4};
  box-shadow: ${({ theme }) =>
    `0 5px 10px ${transparentize(0.95, theme.colors.black)}`};
`;

export const StyledPopover = styled.div`
  ${PopoverContentsStyles};
  position: absolute;
  /* Modals start at 1050 and increase by 10 for each additional nested modal */
  z-index: 1100;
  display: block;
  box-sizing: border-box;
  overflow-y: auto;
  transition: opacity 0.1s ease;
`;
